/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateFileArticlesParams } from '../models/create-file-articles-params';
import { CreateFilePieceListsResult } from '../models/create-file-piece-lists-result';
import { CreateFilesParamsV2 } from '../models/create-files-params-v-2';
import { CreateFilesResultV2 } from '../models/create-files-result-v-2';

@Injectable({ providedIn: 'root' })
export class PlanFileApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createPlanFiles()` */
  static readonly CreatePlanFilesPath = '/api/v1/plans/{planId}/plan-files';

  /**
   * Creates plan files in engineering hub.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanFiles$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanFiles$Plain$Response(
    params: {
      planId: number;
      body: CreateFilesParamsV2
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CreateFilesResultV2>> {
    const rb = new RequestBuilder(this.rootUrl, PlanFileApiClient.CreatePlanFilesPath, 'post');
    if (params) {
      rb.path('planId', params.planId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateFilesResultV2>;
      })
    );
  }

  /**
   * Creates plan files in engineering hub.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanFiles$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanFiles$Plain(
    params: {
      planId: number;
      body: CreateFilesParamsV2
    },
    context?: HttpContext
  ): Observable<CreateFilesResultV2> {
    return this.createPlanFiles$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateFilesResultV2>): CreateFilesResultV2 => r.body)
    );
  }

  /**
   * Creates plan files in engineering hub.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanFiles()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanFiles$Response(
    params: {
      planId: number;
      body: CreateFilesParamsV2
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CreateFilesResultV2>> {
    const rb = new RequestBuilder(this.rootUrl, PlanFileApiClient.CreatePlanFilesPath, 'post');
    if (params) {
      rb.path('planId', params.planId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateFilesResultV2>;
      })
    );
  }

  /**
   * Creates plan files in engineering hub.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanFiles$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanFiles(
    params: {
      planId: number;
      body: CreateFilesParamsV2
    },
    context?: HttpContext
  ): Observable<CreateFilesResultV2> {
    return this.createPlanFiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateFilesResultV2>): CreateFilesResultV2 => r.body)
    );
  }

  /** Path part for operation `createPlanPieceLists()` */
  static readonly CreatePlanPieceListsPath = '/api/v1/plans/{planId}/plan-piecelists';

  /**
   * Creates plan piecelists in engineering hub.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanPieceLists$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanPieceLists$Plain$Response(
    params: {
      planId: number;
      body: CreateFileArticlesParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CreateFilePieceListsResult>> {
    const rb = new RequestBuilder(this.rootUrl, PlanFileApiClient.CreatePlanPieceListsPath, 'post');
    if (params) {
      rb.path('planId', params.planId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateFilePieceListsResult>;
      })
    );
  }

  /**
   * Creates plan piecelists in engineering hub.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanPieceLists$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanPieceLists$Plain(
    params: {
      planId: number;
      body: CreateFileArticlesParams
    },
    context?: HttpContext
  ): Observable<CreateFilePieceListsResult> {
    return this.createPlanPieceLists$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateFilePieceListsResult>): CreateFilePieceListsResult => r.body)
    );
  }

  /**
   * Creates plan piecelists in engineering hub.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanPieceLists()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanPieceLists$Response(
    params: {
      planId: number;
      body: CreateFileArticlesParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CreateFilePieceListsResult>> {
    const rb = new RequestBuilder(this.rootUrl, PlanFileApiClient.CreatePlanPieceListsPath, 'post');
    if (params) {
      rb.path('planId', params.planId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateFilePieceListsResult>;
      })
    );
  }

  /**
   * Creates plan piecelists in engineering hub.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanPieceLists$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanPieceLists(
    params: {
      planId: number;
      body: CreateFileArticlesParams
    },
    context?: HttpContext
  ): Observable<CreateFilePieceListsResult> {
    return this.createPlanPieceLists$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateFilePieceListsResult>): CreateFilePieceListsResult => r.body)
    );
  }

}
